export const navLinks = [
  { label: "Accueil", href: "#top" },
  { label: "Expertises", href: "#expertises" },
  { label: "Secteur des jeux", href: "#secteur" },
  { label: "Méthode", href: "#methode" },
  { label: "À propos", href: "#a-propos" },
];

export const expertises = [
  {
    title: "Veille législative et réglementaire",
    summary:
      "Anticiper les textes qui transformeront votre activité, bien avant leur adoption.",
    details: [
      "Suivi des travaux parlementaires, nationaux et européens",
      "Analyse d'impact des projets de loi, décrets et délibérations",
      "Notes de synthèse et alertes adaptées à vos priorités",
    ],
  },
  {
    title: "Stratégie d'affaires publiques",
    summary:
      "Construire une position claire, crédible et défendable auprès des décideurs.",
    details: [
      "Cartographie des acteurs et des rapports de force",
      "Élaboration des messages clés et des argumentaires",
      "Feuille de route d'influence alignée sur votre calendrier business",
    ],
  },
  {
    title: "Relations institutionnelles",
    summary:
      "Ouvrir et entretenir un dialogue de qualité avec les pouvoirs publics.",
    details: [
      "Organisation de rencontres avec parlementaires, cabinets et administrations",
      "Préparation aux auditions et consultations publiques",
      "Accompagnement dans les échanges avec le régulateur",
    ],
  },
  {
    title: "Plaidoyer et coalitions",
    summary:
      "Fédérer les acteurs du secteur pour porter une voix collective plus forte.",
    details: [
      "Rédaction de contributions et de propositions d'amendements",
      "Animation de coalitions et dialogue avec les fédérations professionnelles",
      "Mise en relation avec les parties prenantes de la société civile",
    ],
  },
];

export const sectorTopics = [
  {
    title: "Régulation et agréments",
    text: "Cadre d'agrément des opérateurs, évolutions des obligations et dialogue avec l'Autorité nationale des jeux.",
  },
  {
    title: "Publicité et communication",
    text: "Encadrement des campagnes, du parrainage sportif et des partenariats avec les créateurs de contenu.",
  },
  {
    title: "Jeu responsable",
    text: "Protection des mineurs, prévention du jeu excessif et outils de modération des joueurs.",
  },
  {
    title: "Fiscalité des jeux",
    text: "Prélèvements sur les mises et le produit brut des jeux, débats budgétaires annuels.",
  },
  {
    title: "Lutte contre l'offre illégale",
    text: "Blocage des sites non agréés, coopération avec les plateformes et moyens d'action du régulateur.",
  },
  {
    title: "Cadre européen",
    text: "Libre prestation de services, initiatives de la Commission et convergence des régulations nationales.",
  },
];

export const methodSteps = [
  {
    title: "Diagnostic",
    text: "Comprendre votre modèle, vos contraintes et l'agenda politique qui vous concerne.",
  },
  {
    title: "Cartographie",
    text: "Identifier les décideurs, les relais d'opinion et les fenêtres d'opportunité.",
  },
  {
    title: "Stratégie",
    text: "Définir les messages, les canaux et un calendrier d'actions priorisé.",
  },
  {
    title: "Action et suivi",
    text: "Porter vos positions sur le terrain et mesurer les avancées, étape par étape.",
  },
];

export const faqs = [
  {
    question: "Qu'est-ce que le répertoire de la HATVP ?",
    answer:
      "La Haute Autorité pour la transparence de la vie publique tient un répertoire public des représentants d'intérêts. Les personnes qui en relèvent y déclarent chaque année leurs activités et les moyens qui y sont consacrés. L'activité d'Éléonore Para y est référencée.",
  },
  {
    question: "Quels types d'entreprises accompagnez-vous ?",
    answer:
      "Principalement des opérateurs de jeux en ligne, des fournisseurs de technologies et des acteurs de l'écosystème des paris sportifs et du poker, ainsi que des entreprises d'autres secteurs régulés.",
  },
  {
    question: "Intervenez-vous ponctuellement ou dans la durée ?",
    answer:
      "Les deux. L'accompagnement peut prendre la forme d'une mission ciblée, pour un texte ou une échéance précise, ou d'un suivi continu de vos enjeux institutionnels.",
  },
  {
    question: "Comment se déroule un premier échange ?",
    answer:
      "Un entretien confidentiel d'environ 45 minutes permet de comprendre votre situation et d'identifier les leviers prioritaires. Une proposition d'accompagnement vous est ensuite adressée.",
  },
];
